// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"484":"67a9b6d2","551":"1ebc5ba7"}[chunkId] + ".chunk.js";
};